import React, { useEffect, useState } from 'react';
import AlertBoxPL from '@RHEnvironmental/pattern-library/dist/js/components/AlertBox';
import { useDispatch, useSelector } from 'react-redux';
import {
    clearAlert,
    ID_DELIMITER,
    registerAlertbox,
    SECTIONS_DELIMITER,
    unregisterAlertbox,
} from '../../../actions/alerts';

const generateID = (() => {
    let globalIdCounter = 0;
    return (baseId) => `${baseId}${globalIdCounter++}`;
})();

const AlertBox = ({ section, className }) => {
    const dispatch = useDispatch();
    const { alert } = useSelector((state) => state.alerts);
    const [show, setShow] = useState(false);

    const sections =
        typeof typeof (section || '') === 'string'
            ? Array(section || '')
            : section;

    const [id] = useState(
        generateID(`${sections.join(SECTIONS_DELIMITER)}${ID_DELIMITER}`)
    );

    useEffect(() => {
        const sectionsMatch =
            sections.findIndex((item) => item === alert.section) !== -1;
        const hasMessage = alert.message && setShow.length > 0;
        setShow(sectionsMatch && hasMessage);
    }, [alert, sections]);

    useEffect(() => {
        dispatch(registerAlertbox(id));

        return () => {
            dispatch(unregisterAlertbox(id));
            dispatch(clearAlert());
        };
    }, []);

    return show ? (
        <AlertBoxPL className={className} theme={alert.theme}>
            <p>{alert.message}</p>
        </AlertBoxPL>
    ) : null;
};

export default AlertBox;
